<template>
  <v-flex xs12 sm6 md6 lg4 xl3 px-2 mb-2>
    <v-hover>
      <v-card
        class="usercard-main pr-4 pl-3 py-2 mb-2 rounded-3"
        color="cardBackground"
        slot-scope="{ hover }"
        :class="`elevation-${hover ? 5 : 2}`"
        v-if="cardAction"
      >
        <v-card-title class="pa-0 pb-1 pt-1">
          <v-flex shrink d-inline-block style="width: 65px">
            <UserAvatar
              :user-id="cardContent.id"
              avatarOnly
              :avatarURL="avatar"
              :name="name"
              size="50px"
            >
            </UserAvatar>
          </v-flex>
          <v-flex d-inline-block style="width: calc(100% - 120px)">
            <h3
              class="icon-bold-link primary--text text-truncate mt-1 mb-1 pb-1 pr-4 ml-0"
            >
              {{ cardContent.displayName }}
            </h3>
            <h4 v-if="statusLabel" class="text-truncate pr-4">
              <span class="primary--text body-1 opacity-54 pt-1"
                >Status -</span
              >
              <span
                class="pl-1 pt-1 primary-text body-1 opacity-54 font-weight-bold"
                >{{ statusLabel }}</span
              >
            </h4>
            <h4 class="text-truncate pr-4">
              <span class="primary--text body-1 opacity-54 pt-1"
                >Last seen -</span
              >
              <span
                class="pl-1 pt-1 primary-text body-1 opacity-54 font-weight-bold"
                >{{ formattedTime }}</span
              >
            </h4>
            <h4 class="text-truncate pr-4">
              <span class="primary--text body-1 opacity-54 pt-1"
                >MFA Enabled -</span
              >
              <span
                class="pl-1 pt-1 primary-text body-1 opacity-54 font-weight-bold"
                >{{mfaEnabled}}</span
              >
            </h4>
          </v-flex>
        </v-card-title>
        <v-card-actions v-if="cardAction" class="card-vert-menu">
          <v-btn
            flat
            icon
            v-if="addAction"
            color="success"
            class="ma-0"
            style="
              margin-top: calc(50% - 7px) !important;
              margin-left: -10px !important;
            "
            @click="addUser(cardContent)"
          >
            <v-icon>add_circle</v-icon>
          </v-btn>
          <v-btn
            flat
            icon
            v-if="!addAction"
            class="ma-0"
            color="error"
            style="
              margin-top: calc(50% - 7px) !important;
              margin-left: -10px !important;
            "
            @click="removeUser(cardContent)"
          >
            <v-icon>remove_circle</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card
        class="usercard-main pr-4 pl-3 py-2 mb-2 rounded-3"
        color="cardBackground"
        slot-scope="{ hover }"
        :class="`elevation-${hover ? 5 : 2}`"
        v-else
      >
        <router-link :to="route" class="no-link-style">
          <v-card-title class="pa-0 pb-1 pt-1">
            <v-flex shrink d-inline-block style="width: 65px">
              <UserAvatar
                :user-id="cardContent.id"
                avatarOnly
                :avatarURL="avatar"
                :name="name"
                size="50px"
              >
              </UserAvatar>
            </v-flex>
            <v-flex d-inline-block style="width: calc(100% - 120px)">
              <h3
                class="icon-bold-link primary--text text-truncate mt-1 mb-1 pb-1 pr-2 ml-0"
              >
                {{ cardContent.displayName }}
              </h3>
              <h4 v-if="statusLabel" class="text-truncate pr-2">
                <span class="primary--text body-1 opacity-54 pt-1"
                  >Status -</span
                >
                <span
                  class="pl-1 pt-1 primary-text body-1 opacity-54 font-weight-bold"
                  >{{ statusLabel }}</span
                >
              </h4>
              <h4 class="text-truncate pr-2">
                <span class="primary--text body-1 opacity-54 pt-1"
                  >Last seen -</span
                >
                <span
                  class="pl-1 pt-1 primary-text body-1 opacity-54 font-weight-bold"
                  >{{ formattedTime }}</span
                >
              </h4>
              <h4 class="text-truncate pr-4">
                <span class="primary--text body-1 opacity-54 pt-1"
                  >MFA Enabled -</span
                >
                <span
                  class="pl-1 pt-1 primary-text body-1 opacity-54 font-weight-bold"
                  >{{mfaEnabled}}</span
                >
              </h4>              
            </v-flex>
          </v-card-title>
        </router-link>
        <v-card-actions v-if="cardAction" class="card-vert-menu">
          <v-btn
            flat
            icon
            v-if="addAction"
            color="success"
            class="ma-0"
            style="
              margin-top: calc(50% - 7px) !important;
              margin-left: -10px !important;
            "
            @click="addUser(cardContent)"
          >
            <v-icon>add_circle</v-icon>
          </v-btn>
          <v-btn
            flat
            icon
            v-if="!addAction"
            class="ma-0"
            color="error"
            style="
              margin-top: calc(50% - 7px) !important;
              margin-left: -10px !important;
            "
            @click="removeUser(cardContent)"
          >
            <v-icon>remove_circle</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-hover>
  </v-flex>
</template>

<script>
import { mapState } from "vuex";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import UserAvatar from "@/components/Users/UserAvatar.vue";
import Helpers from "@/helpers.js";

export default {
  name: "UserCard",
  props: ["cardContent", "cardAction"],
  components: { UserAvatar },
  computed: {
    ...mapState({
      currentTeam: (state) => state.teams.current.team,
      timePref: (state) => state.currentUser.me.preferences.dateTimeFormat,
    }),
    addAction() {
      return this.cardAction === "add";
    },
    name() {
      if (this.cardContent.displayName) {
        return this.cardContent.displayName;
      } else {
        return "";
      }
    },
    avatar() {
      return Helpers.isPresent(this.cardContent.avatar_url)
        ? this.cardContent.avatar_url
        : "";
    },
    route() {
      if (this.cardContent.__typename === "User") {
        return "users/" + this.cardContent.id + "/profile";
      } else {
        return "teams/" + this.cardContent.id;
      }
    },
    mfaEnabled() {
      return this.cardContent.mfaEnabled ? "Yes" : "No"
    },
    statusLabel() {
      // Team cards reuse this component and have no login/invite state.
      if (!this.cardContent.email) {
        return null
      }
      if (this.cardContent.allowedToLogin === false) {
        return "Login disabled"
      }
      if (this.cardContent.confirmedAt === null) {
        const expiresAt = this.cardContent.inviteExpiresAt
        if (expiresAt && new Date(expiresAt).getTime() < Date.now()) {
          return "Invite expired"
        }
        return "Pending invite"
      }
      return "Active"
    },
    formattedTime() {
      dayjs.extend(advancedFormat);
      if (this.cardContent.lastSeen == null) {
        return "Never";
      }
      if (this.timePref != null) {
        return dayjs(this.cardContent.lastSeen).format(this.timePref);
      } else {
        return this.cardContent.lastSeen;
      }
    },
  },
  methods: {
    editCard() {
      if (!this.cardAction) {
        this.$router.push({
          name: "UserEdit",
          params: { id: this.cardContent.id },
        });
      }
    },
    async addUser(user) {
      await this.$store.dispatch("createTeamMembership", {
        teamId: parseInt(this.currentTeam.id),
        userId: parseInt(user.id),
      });
    },
    async removeUser(user) {
      await this.$store.dispatch("deleteTeamMembership", {
        teamId: parseInt(this.currentTeam.id),
        userId: parseInt(user.id),
      });
    },
  },
};
</script>
